/**
 * The state of one thing, in five states and no more (admin-design-r1). Always with words: beside it, or in its label
 * for screen readers. Signal (down) means down, or High and not yet acknowledged; one cause gets one red light.
 */
import { cx } from '../cx'
import s from './Light.module.css'

export type LightState = 'ok' | 'work' | 'look' | 'down' | 'off'

export const LIGHT_WORDS: Record<LightState, string> = {
  ok: 'healthy',
  work: 'working',
  look: 'needs a look',
  down: 'down',
  off: 'off or unknown',
}

export function Light({
  state,
  label,
  word,
  size = 'md',
}: {
  state: LightState
  /** What the light is about ("agent"). Shown beside the dot. */
  label?: string
  /** What the state reads as here, instead of the default word ("offline for 12m"). */
  word?: string
  size?: 'sm' | 'md' | 'lg'
}) {
  const say = word ?? LIGHT_WORDS[state]
  return (
    <span className={cx(s.light, s[state], s[size])}>
      <i className={s.dot} aria-hidden="true" />
      {label ? (
        <>
          <span className={s.label}>{label}</span>
          <span className={s.sr}>: {say}</span>
        </>
      ) : (
        <span className={s.sr}>{say}</span>
      )}
    </span>
  )
}
